import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { UserCopyTableProfilesPayload } from 'api/actions/user-copy-table-profiles/user-copy-table-profiles-payload';
import { UserCopyTableProfilesPathParameters } from 'api/actions/user-copy-table-profiles/user-copy-table-profiles-path-parameters';
import { UserCopyTableProfilesResponse } from 'api/actions/user-copy-table-profiles/user-copy-table-profiles-response';

type UserCopyTableProfilesQueryParameters = Record<string, any>;

/**
 * The path of the UserCopyTableProfiles action.
 */
export const userCopyTableProfilesActionPath = new SweetPath<keyof UserCopyTableProfilesPathParameters>(
  '/api/user/table-profiles/copy',
  { path: '{param}' }
);

/**
 * Creates a contextualized UserCopyTableProfiles actions.
 */
export default function createUserCopyTableProfilesAction(axios: AxiosInstance) {
  return function userCopyTableProfilesAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: UserCopyTableProfilesQueryParameters;
    payload: UserCopyTableProfilesPayload;
  }) {
    const path = userCopyTableProfilesActionPath.original;

    return axios.request<UserCopyTableProfilesResponse, UserCopyTableProfilesResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
